<template>
  <!-- 模型信息 -->
  <div class="model-information-box">
    <!-- <h4>模型信息:</h4> -->
    <div class="version-list" v-if="modelInformation && modelInformation.trainModelId">
      <h4>模型信息</h4> 
      <div class="version-list-content">
        <div class="meta meta-index"  v-if="modelInformation.reportData && modelInformation.trainModelStatus != 5">
          <span>模型评估指标:</span>
          <span>{{ getReportData(modelInformation.reportData) }}</span>
        </div>
        <dl class="meta" v-if="modelInformation.trainModelStatus == 3">
          <dt>模型ID:</dt>
          <dd>{{modelInformation.trainModelId}}</dd>
        </dl>
        <dl class="meta dataset">
          <dt>数据集:</dt>
          <dd>
            <span>{{ modelInformation.datasetName }}</span>
            <!-- <span>{{`有效${modelTypeCompany(modelType)} ${modelInformation.fileNum} ${modelType==1 || modelType==2 ? '张':'个'}`}}</span> -->
            <span>{{`${getTrainingModelTypeName(modelInformation.fileNum)}`}}</span>
          </dd>
        </dl>
        <dl class="meta">
          <dt>训练时间:</dt>
          <dd>
            {{
              modelInformation.trainBeginTime ||
                modelInformation.trainEndTime | moment("YYYY-MM-DD HH:mm:ss")
            }}
          </dd>
        </dl>
        <span class="line"></span>
        <div class="meta">
          <div class="btn-opt">
            <span>{{ modelInformation.trainModelStatus | trainModelStatusTransform }}</span>
            <!-- 倒计时 -->
            <span class="date-span" v-if="modelInformation.trainModelStatus == 1">预计{{estimatedTime(modelInformation.remainingTime)}}完成</span>
            <span class="date-span" v-if="modelInformation.trainModelStatus == 2">未发布</span>
            <span :class="['delete-span', {'events-disable': teacherOrStudentState ? (withdrawReleaseStatus || releaseStatus) : releaseStatus}]"  @click="activeDeletePopup(modelInformation)">删除</span>
          </div>
        </div>
      </div>
    </div>
    <div class="no-version" v-else>
      <span class="state-span">模型信息：<span class="state-text">未训练</span></span>
    </div>

    <!-- 删除弹窗 -->
    <PopupDeleteBox
      :deleteData="deleteData"
      :popupActive="popupActive"
      @confirmPopup="confirmPopup"
      @cancelPopup="cancelPopup"
    ></PopupDeleteBox>
  </div>
</template>

<script>
import MARKCENTER from '@/axios/trainingCenter/MarkCenter/MarkCenter.js' // 项目标注接口
import PopupDeleteBox from '@/components/common/PopupDeleteBox'

import { debounce } from 'lodash' // 引入lodash数组函数方法

export default {
  name: "ModelInformationBox",
  components: { PopupDeleteBox },
  props: {
    trainingId: {
      type: String,
      default: ''
    },
    navType: {
      type: String,
      default: ''
    },
    modelType: {
      type: String,
      default: ''
    },
    modelInformation: {
      type: Object,
      default: {}
    },
    releaseStatus: {
      type: Boolean,
      default: false
    },
    trainModelShow: {
      type: Boolean,
      default: false
    },
    withdrawReleaseStatus: {
      type: Boolean,
      default: false
    },
    teacherOrStudentState: {
      type: Boolean,
      default: false
    },
    quoteModelNum: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      popupData: {
        trainModelId: '',
        trainModelStatus: '',
      },
      deleteData: {
        popupType: '1', // 1：有content内容， 2：无content内容
        popupFlag: 'delete', // 对应弹窗类型
        buttonText: '删除', // 按钮文字
        title: '确定删除版本模型吗？', // 标题
        content: '删除后可重新训练模型！' // 内容
      },
      popupActive: '',
    }
  },
  filters: {
    // 训练模型状态处理
    trainModelStatusTransform(value) {
      var status = ["", "训练进行中", "训练完成", "已发布", "已下线", "训练失败"];
      return status[value];
    },
  },
  computed: {},
  watch: {
    quoteModelNum: {
      // 删除模型将会同步重置实训考核设置！
      handler(val) {
        this.getDeleteTips();
      },
      deep: true,
      immediate: true,
    },
    trainModelShow: {
      // 删除模型将会同步重置实训考核设置！
      handler(val) {
        this.getDeleteTips();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  methods: {
    getDeleteTips() {
      this.deleteData.content = this.quoteModelNum != 0 
        ? `该模型所在实训项目已被${this.quoteModelNum}个项目引用，删除后可重新训练模型！` 
        : (this.teacherOrStudentState && this.trainModelShow
        ? '删除模型将会同步重置实训考核设置！' : '删除后可重新训练模型！');
    },
    // 模型类别单位过滤
    modelTypeCompany(type) {
      if (type == 1 || type == 2) {
        return '图片';
      } else if (type == 3 || type == 4) {
        return '文本';
      } else if (type == 5 || type == 6) {
        return '音频';
      }
    },
    getTrainingModelTypeName(fileNum) {
      let modelType = this.modelType,
       typeName = modelType == 2 ? '有效已标注图片数' : `有效${this.modelTypeCompany(modelType)}${modelType==4 || modelType==6 ? '标注':''}数`,
       text = `${typeName} ${fileNum} ${modelType==1 || modelType==2 ? '张':'个'}`;
      return text
    },
    getReportData(val) {
      let accuracy = ''
      if (val) {
        accuracy = JSON.parse(val)
      }
      return accuracy.Accuracy || accuracy.mAP
    },
    // 时间戳转日期时间格式'yy-MM-dd hh:mm:ss'
    getdate(val) {
      var date = new Date(val);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return YY + MM + DD +" "+ hh + mm + ss;
    },
    // 返回预计时间格式
    estimatedTime(val) {
      var date = new Date();
      var timeStamp = date.getTime(); // 当前时间戳
      var addMinutes = val * 60 * 1000; // 预计时间戳
      var estimatedTimeStamp = timeStamp + addMinutes;

      var currentdate = this.getdate(estimatedTimeStamp);
      // console.log('当前时间',currentdate)
      return currentdate;
    },
    // 模型删除激活
    activeDeletePopup(val) {
      this.$emit('getQuoteModelNum'); // 查询被引用数量
      this.popupData.trainModelId = val.trainModelId;
      this.popupData.trainModelStatus = val.trainModelStatus;
      this.popupActive = "delete";
    },
    // 确认删除
    confirmPopup(type) {
      if (type === 'delete') {
        let data = {
          trainingId: this.trainingId, // 实训id
          trainModelId: this.popupData.trainModelId, // 训练模型id
          trainModelStatus: this.popupData.trainModelStatus, // 训练模型状态：1:进行中;2:训练完成;3:已发布;4:已下线
        }

        MARKCENTER.deleteTrainingModel(data).then((result) => {
          if (result.isSuccess) {
            this.$message.success(result.returnMsg);
            this.cancelPopup()
            this.$emit('toModelTrain')
          } else {
            this.$message.error(result.returnMsg);
          }
        })
      }
    },
    // 取消删除
    cancelPopup() {
      this.popupActive = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.model-information-box {
  width: 290px;
  margin-left: 12px;
  .version-list {
    width: 100%;
    min-height: 168px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #D8E5FD;
    margin-top: 20px;
    overflow: hidden;
    &:first-child {
      margin-top: 0;
    }
    h4 {
      height: 40px;
      background: #4C88FF;
      border-radius: 4px 4px 0px 0px;
      color: #FFFFFF;
      font-size: 14px;
      line-height: 40px;
      padding: 0 12px;
    }
    .version-list-content {
      color: #333333;
      font-size: 14px;
      padding: 16px 12px;
      .meta-index {
        display: flex;
        align-items: center;
        span:first-child {
          margin-right: 0.5em;
        }
      }
      .meta {
        margin-bottom: 6px;
        font-size: $font_size;
        color: $font_333_color;
        display: flex;
        // align-items: center;
        dt {
          min-width: 60px;
          margin-right: 0.5em;
          text-align: justify;
          text-align-last: justify;
        }
        dd {
          min-width: 200px;
          line-height: 20px;
          word-wrap: break-word;
        }
        &.dataset {
          span:first-child {
            margin-right: 1em;
          }
        }
        .btn-opt {
          width: 100%;
          span {
            margin-right: 1em;
          }
          // .date-span {}
          .delete-span {
            color: #4c88ff;
            cursor: pointer;
          }
        }
      }
    }
    .line {
      width: 266px;
      height: 1px;
      background: #D8E5FD;
      display: block;
      margin: 14px auto;
    }
  }
  .no-version {
    line-height: 36px;
    padding: 0 10px;
    .state-span {
      color: #333;
      font-size: 14px;
      .state-text {
        color: #ec414c;
      }
    }
  }

  ::v-deep.popup-delete-box .popup-delete .popup-inner {
    width: 520px;
    // height: 230px;
  }
}
</style>